import axios from "axios";
import * as storage from "./storage";
//import utils from './utils'
import jwt_decode from "jwt-decode";
import services from ".";
import globals from "../globals";

const APIROOT = globals.REACT_APP_URL_BASE_API;
const CancelToken = axios.CancelToken;
let cancel;

axios.interceptors.request.use(
  async function (config) {
    // Do something before request is sent
    let newConfig = {};
    if (config) {
      newConfig = config;
    }

    try {
      if (
        newConfig.url.startsWith(APIROOT) &&
        !newConfig.url.startsWith(APIROOT + "buyer") &&
        !newConfig.url.endsWith("login") &&
        !newConfig.url.endsWith("login") &&
        !newConfig.url.endsWith("usuario/senha/resetar") &&
        !newConfig.url.endsWith("primeiro-acesso-seller")
      ) {
        let tokenData = storage.get("authSistema");
        //console.log(tokenData.token);

        if (tokenData && tokenData.token) {
          let decoded = jwt_decode(tokenData.token);
          let isExpired = _isExpired(decoded.exp);

          if (isExpired) {
         
            services.storage.clear();
            window.open(window.location.hostname);
          }

          newConfig.headers = {
            ...newConfig.headers,
            Authorization: `Bearer ${tokenData.token}`,
          };
        }
      }
      return newConfig;
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  function (error) {
    //console.log(error)
    // Do something with request error
    return Promise.reject(error);
  }
);

const _isExpired = (dataEx) => {
  let dataExformat = dataEx * 1000;
  if (Date.now() >= dataExformat) {
    return true;
  }
  return false;
};

export const _sendWithAxios = async (url, method, payload, params) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
      params: params,
    });

    /*  if (url.startsWith(APIADDRESS)) return { data: result.data, fail: null } */
    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};
const _sendWithAxiosCancelPrev = async (url, method, payload) => {
  if (cancel != undefined) {
    cancel();
  }
  try {
    const result = await axios({
      url: url,
      method: method,
      data: payload,
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    });
    return { data: result.data.data, fail: null, status: result.status };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

export const _sendWithAxiosBlob = async (url, method, payload) => {
  try {
    const result = await axios({
      url: url,
      method: method,
      responseType: "blob",
      data: payload,
    });
    return { data: result.data, fail: null };
  } catch (error) {
    const errors = _parseError(error);
    return { data: false, fail: true, errors };
  }
};

const _parseError = (error) => {
  let errors = [];
  const { response, isAxiosError } = error;
  if (response && response.data) {
    const { data } = response;
    errors = data || [];
  } else if (isAxiosError) {
    errors.push({ message: "Falha ao enviar dados ao servidor" });
  }
  return errors;
};

////// geral
export const logar = async (acessParams) => {
  return await _sendWithAxios(`${APIROOT}login`, "POST", acessParams);
};
export const resetarSenha = async (cpf) => {
  let obj = { UserName: cpf };
  return await _sendWithAxios(`${APIROOT}usuario/senha/resetar`, "POST", obj);
};

/* export const empresasUploadImg = async (file) => {
    const data = new FormData()
    data.append("file", file)
    return await _sendWithAxios(`${APIROOT}upload/logo-empresa`, 'POST', data)
}
export const candidatoUploadCurriculo = async (file) => {
    const data = new FormData()
    data.append("file", file)
    return await _sendWithAxios(`${APIROOT}upload/curriculos-candidatos`, 'POST', data)
} */
